import { GetItemUploadCatalogsResp } from 'types/api/response/get-item-upload-catalogs-resp'

import { api } from './api'

export const getItemUploadCatalogs = () =>
  api.get<GetItemUploadCatalogsResp>('/item_upload/catalogs')
